import {defineToolkit} from '@assistant-ui/react';

import {AskUserToolUI} from './AskUserToolUI';
import {NetworkAccessToolUI} from './NetworkAccessToolUI';
import {RunFilterToolUI, SET_RUN_FILTER_TOOL_NAME} from './RunFilterToolUI';

/**
 * wbAgentToolkit defines the collection of frontend tools registered with AUI.
 * Set `disabled` to true to omit a tool from model context, but still register
 * its renderer; this is useful for backend owned tools which still get a UI.
 *
 * NOTE: Most tools can define `parameters` as a generic (i.e. permissive)
 * placeholder, since AUI will just pass them verbatim to the runtime (and
 * validation can be consolidated there).
 */
export const wbAgentToolkit = defineToolkit({
  ask_user: {
    type: 'human',
    disabled: true,
    parameters: {type: 'object'},
    render: AskUserToolUI,
  },
  request_network_access: {
    type: 'human',
    disabled: true,
    parameters: {type: 'object'},
    render: NetworkAccessToolUI,
  },
  [SET_RUN_FILTER_TOOL_NAME]: {
    type: 'backend',
    display: 'standalone',
    render: RunFilterToolUI,
  },
});
